export const login = async () => {
  const r1 = location.pathname + location.search
  const r2 = `${location.origin}/qq-login-cb?r=${encodeURIComponent(r1)}`
  const rx = `https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101982219&redirect_uri=${encodeURIComponent(
    r2
  )}&scope=get_user_info`

  window.location.href = rx
}
